import {useEffect, useState} from 'react';
import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@/shadcn_components/ui/resizable';
import {Sidebar} from './sidebar';
import { CommentSection } from './components/comment-section';

interface ConversationLayoutProps {
  defaultLayout: number[] | undefined;
}

export function ConversationLayout({defaultLayout = [320, 480]}: ConversationLayoutProps) {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenWidth = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkScreenWidth();

    // Event listener for screen width changes
    window.addEventListener('resize', checkScreenWidth);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('resize', checkScreenWidth);
    };
  }, []);

  return (
    <ResizablePanelGroup
      direction="horizontal"
      onLayout={(sizes: number[]) => {
        document.cookie = `react-resizable-panels:layout=${JSON.stringify(sizes)}`;
      }}
      className="h-full items-stretch">
      <ResizablePanel
        defaultSize={defaultLayout[0]}
        minSize={isMobile ? 0 : 24}
        maxSize={isMobile ? 8 : 30}>
        <Sidebar isMobile={isMobile} />
      </ResizablePanel>
      <ResizableHandle withHandle />
      <ResizablePanel defaultSize={defaultLayout[1]} minSize={30}>
        <CommentSection />
        {/* <Chat messages={selectedUser.messages} selectedUser={selectedUser} isMobile={isMobile} /> */}
      </ResizablePanel>
    </ResizablePanelGroup>
  );
}
